import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PropType } from 'vue';
import { ref, toRefs } from 'vue';

// PERSONAL COMPONENTS
import QBtnCancel from '@components/form/QBtnCancel.vue';
import QBtnValid from '@components/form/QBtnValid.vue';
import QDialogTemplate from '@components/template/QDialogTemplate.vue';

// PERSONAL LIBS
import adminRepository from '@data/repository/admin.repository';
import {
  displayDialogError,
  displayDialogSuccess,
} from '@shared/lib/notify.lib';
import { IUser } from '@shared/interface/model.interface';

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogUserNewPassword',
  props: {
  show: { type: Boolean, required: true, default: false },
  user: { type: Object as PropType<IUser>, required: true, default: '' }
},
  emits: ['close', 'success', 'failed'],
  setup(__props, { emit: __emit }) {

// VENDOR
const emits = __emit;

/**
 * Reactive datas
 */
const loading = ref<boolean>(false);

/**
 * Properties
 */
const props = __props;
const { show, user } = toRefs(props);

/**
 * Methods
 */
function onClose() {
  emits('close');
}

function onValid() {
  loading.value = true;

  adminRepository
    .passwordRenew(user.value.email)
    .then(() => {
      displayDialogSuccess({
        message: `Un nouveau mot de passe vient d'être envoyé à l'utilisateur '${user.value.username}'.`,
      });
      emits('success');
      emits('close');
    })
    .catch((error) => displayDialogError({ message: error.message ?? 'null' }))
    .finally(() => (loading.value = false));
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(QDialogTemplate, {
    "show-dialog": _unref(show),
    ref: "qDialogTemplate",
    title: 'Suppression',
    onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose()))
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-my-md" }, {
            default: _withCtx(() => [
              _createTextVNode(" Cette action permet de générer un mot de passe aléatoire et temporaire (10 minutes) pour l'utilisateur '" + _toDisplayString(_unref(user).username) + "'. ", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(QBtnCancel, {
                label: 'Annuler',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose())),
                disable: loading.value
              }, null, 8 /* PROPS */, ["disable"]),
              _createVNode(QBtnValid, {
                label: 'Générer',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onValid())),
                disable: loading.value,
                loading: loading.value,
                "loading-label": ''
              }, null, 8 /* PROPS */, ["disable", "loading"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-dialog"]))
}
}

})